import styled from "styled-components";
import { Picker, Space } from "antd-mobile";
import { DownFill } from "antd-mobile-icons";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

export default function Select({ defaultSelected = '' ,onConfirm=(val, extend) => {}, list = [[]]}) {
  const [seleted, setSelect] = useState([defaultSelected]);
  
  const toI18n = (arr) => {
    return arr.map(e => {
      return {
        ...e,
        label: intl.formatMessage({
          id: e.i18n,
          defaultMessage: e.label,
        })
      }
    }) 
  }
  const intl = useIntl()
  const [columns, setColumns] = useState(() => {
    return [toI18n(list[0])]
  })

  useEffect(() => {
    setColumns([toI18n(list[0])])
  },[list])
  return (
    <Picker
      columns={columns}
      confirmText={
        intl.formatMessage({
          id: 'common.confrim',
          defaultMessage: '確定',
        })
      }
      cancelText = {
        intl.formatMessage({
          id: 'common.cancel',
          defaultMessage: '取消',
        })
      }
      value={seleted}
      onConfirm={(val,e) => {
        setSelect(val)
        onConfirm(val,e)
      }}
    >
      {(items, { open }) => {
        return (
          <Space align="center">
            <Wrapper onClick={open}>
              <SelectedText>
                {items.map((item) => item.label || "全部").join("")}
              </SelectedText>
              <div style={{ float: "right" }}>
                <DownFill />
              </div>
            </Wrapper>
          </Space>
        );
      }}
    </Picker>
  );
}

const Wrapper = styled.div`
  display: inline-block;
  background: #b4b0f536;
   
  border-radius: .5rem;
  width: 6.0rem;
  padding: .6rem 1.0rem;
  text-align: center;
`;
const SelectedText = styled.span`
  /* margin-right:1.5rem; */
`;
